/** Shape needed to tell team owner / solo vs shared seat (see session user + rootSlice). */
export type UserForTeamOwnerCheck = {
  email?: string | null
  owner?: string | null
}

/** True when the signed-in account is the team owner, or a solo account with no `owner` field. */
export function isTeamOwner(user: UserForTeamOwnerCheck | null | undefined): boolean {
  if (!user) return false
  return user.email === user.owner || !user.owner
}
